const API_BASE = "https://api.lexikonn.eu/amnesia";
export async function apiGet(path, opts={}) {
    const r = await fetch(`${API_BASE}${path}`, { credentials: "include", ...opts });
    return r.json();
}
export async function apiPost(path, data) {
    const r = await fetch(`${API_BASE_URL}${path}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    });
    const text = await r.text();
    let json;
    try { json = JSON.parse(text); } catch { json = { ok:false, error: `bad_json_response: ${text.slice(0,200)}` }; }
    return json;
}
export const API_BASE_URL = API_BASE;

export async function logout() {
    const r = await fetch(`${API_BASE_URL}/logout.php`, {
        method: "POST",
        credentials: "include"
    });
    return r.json();
}
